import React from 'react';
import { motion } from 'framer-motion';
import VideoBackground from './VideoBackground';

export default function SectionOne() {
  return (
    <section className="py-24 bg-ivory overflow-hidden">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          <motion.div
            initial={{ opacity: 0, x: -30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 1 }}
          >
            <h2 className="text-4xl md:text-5xl text-olive mb-8 leading-tight">Summer at Padua <br/>Feels Different</h2>
            <div className="w-12 h-[1px] bg-gold mb-8"></div>
            <p className="font-sans font-light text-lg leading-relaxed text-olive/80 mb-8">
              A summer wedding at Padua gives couples the beauty of an outdoor estate ceremony with the comfort of an indoor reception experience.
            </p>
            <p className="font-sans font-light text-lg leading-relaxed text-olive/80">
              From shaded ceremony spaces to mature trees and hillside views, every part of the setting is designed to feel romantic, elegant, and comfortable.
            </p>
          </motion.div>
          
          <motion.div
            initial={{ opacity: 0, x: 30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 1, delay: 0.2 }}
            className="relative aspect-video lg:aspect-square"
          >
            <VideoBackground 
              src="https://ik.imagekit.io/aeu02xvjgn/Summer%20Promotion/0508%20(1).mov" 
              poster="https://images.unsplash.com/photo-1519225421980-715cb0215aed?q=80&w=2070&auto=format&fit=crop"
              overlayOpacity="bg-black/10"
              className="rounded-sm"
            />
          </motion.div>
        </div>
      </div>
    </section>
  );
}